<template>
  <!-- 고객 응대 초안 카드(F2) — LLM이 작성한 응대 문구를 [복사]로 가져가 직접 사용한다.
       시스템 저장/발송 없음(쓰기 아님). HITL 카드(DraftConfirmBlock)와 동일 톤. -->
  <div class="aw-reply-draft">
    <div class="aw-rd-title">{{ data.title || $t('assistant.replyDraftTitle') }}</div>
    <div class="aw-rd-body">{{ data.draft }}</div>
    <div v-if="data.note" class="aw-rd-note">{{ data.note }}</div>
    <div class="aw-rd-actions">
      <button
        type="button"
        class="aw-rd-copy"
        :class="{ 'aw-rd-copy--done': copied }"
        @click="copy"
      >
        {{ failed ? $t('assistant.copyFail') : (copied ? $t('assistant.copied') : $t('assistant.copy')) }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * @component ReplyDraftBlock
 * @description 고객 응대 초안 블록. data={title?, draft, note?}.
 *   [복사] 클릭 시 navigator.clipboard로 초안 본문을 복사하고 버튼 라벨을 일시 전환한다.
 */
export default {
  name: 'ReplyDraftBlock',
  props: {
    data: { type: Object, default: () => ({}) }
  },
  data() {
    return { copied: false, failed: false, copyTimer: null }
  },
  beforeUnmount() {
    if (this.copyTimer) clearTimeout(this.copyTimer)
  },
  methods: {
    /** 초안 본문을 클립보드로 복사 — 성공/실패를 버튼 라벨로 2초간 피드백 */
    async copy() {
      const text = String(this.data.draft || '')
      if (!text) return
      try {
        await navigator.clipboard.writeText(text)
        this.copied = true
        this.failed = false
      } catch (e) {
        if (window.__APP_LOG__) window.__APP_LOG__(e)
        this.copied = false
        this.failed = true
      }
      if (this.copyTimer) clearTimeout(this.copyTimer)
      this.copyTimer = setTimeout(() => {
        this.copied = false
        this.failed = false
      }, 2000)
    }
  }
}
</script>

<style scoped>
.aw-reply-draft {
  max-width: 100%;
  background: var(--color-primary-50, #E8EDF4);
  border: 1px solid var(--color-primary-100, #C5D1E3);
  border-radius: 12px;
  padding: 12px;
  white-space: normal;
}
.aw-rd-title { font-weight: 700; font-size: 14px; color: var(--color-primary-500, #3B5998); margin-bottom: 8px; }
/* 초안 본문 — 그대로 복사되는 텍스트임을 드러내는 흰 배경 영역 */
.aw-rd-body {
  background: var(--color-white, #fff);
  border: 1px solid var(--color-gray-200, #e0e0e0);
  border-radius: var(--radius-md, 8px);
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-gray-800, #202124);
  white-space: pre-wrap;
  word-break: break-word;
}
.aw-rd-note { font-size: 12px; color: var(--color-gray-600, #5f6368); margin-top: 6px; }
.aw-rd-actions { display: flex; gap: 8px; margin-top: 10px; }
.aw-rd-copy {
  border: none;
  border-radius: var(--radius-md, 8px);
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: var(--color-primary-500, #3B5998);
  color: var(--color-white, #fff);
}
.aw-rd-copy:hover { background: var(--color-primary-600, #2C4578); }
.aw-rd-copy--done { background: var(--color-success, #2F9E44); }
.aw-rd-copy--done:hover { background: var(--color-success, #2F9E44); }
</style>
